import React from "react";
import SpinnerHandler from "../../../hoc/SpinnerHandler/SpinnerHandler";
import useHttpSection from "../../../hooks/useHttpSection";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";

const WeatherStationTabs = {
  title: "ایستگاه هواشناسی",
  chart: "Chart/WeatherStation",
  values: [
    { value: "نام ایستگاه" },
    { value: "کد ایستگاه" },
    { value: "بارش" },
    { value: "عمق برف" },
    { value: "چگالی برف" },
    { value: "ارتفاع برف" },
    // { value: "دمای حداقل" },
    // { value: "دمای متوسط" },
    // { value: "دمای حداکثر" },
    { value: "تبخیر" },
  ],
  colors: [
    "#f3faf9",
    "#f9f3fa",
    "#f5f3fa",
    "#faf3f4",
    "#faf9f3",
    "#f4faf3",
    // "#f9f3fa",
    // "#f4f3fa",
    // "#f3f8fa",
    "#faf3f9",
  ],
  widths: [
    "200px",
    "100px",
    "70px",
    "100px",
    "100px",
    "100px",
    // "100px",
    // "100px",
    // "100px",
    "100px",
  ],
  totalWidth: 930,
  items: {
    name: 0,
    code: 1,
    latest_update_rain: {
      value: 2,
    },
    latest_update_evp: {
      value: 9,
    },
  },
};

const WeatherStation = (props) => {
  const { data, isLoading } = useHttpSection(props);

  const handleDate = (item,property) => {
    if (item) {
      if (item.date) {
        return moment(item.date).format("jYYYY/jMM/jDD");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  return (
    <SpinnerHandler isLoading={isLoading}>
      <div className="topHeaderContainer">
        <ul className="listTab">
          {WeatherStationTabs.values.map((e, i) => (
            <li
              style={{
                backgroundColor: WeatherStationTabs.colors[i],
                width: WeatherStationTabs.widths[i],
                fontWeight: "bolder",
                fontSize: 14,
              }}
              key={e.value}
            >
              {e.value}
            </li>
          ))}
        </ul>
        <div className="line topline">
          <div></div>
        </div>
      </div>
      {data.map((item) => (
        <div className="rowContainer" key={item.id}>
          <div key={item.id} className="RowWeatherStationContainer">
            <div style={{ display: "flex" }}>
              <div className="item1">
                <p>{item.name}</p>
              </div>
              <div className="item2">
                <p>{item.code}</p>
              </div>
              <div className="item3">
                <p>
                  {item.latest_update_rain && item.latest_update_rain.value}
                </p>
                <p style={{ fontSize: 10 }}>
                  {handleDate(item.latest_update_rain)}
                </p>
              </div>
              <div className="item4">
                <p>
                  {item.latest_update_snow && item.latest_update_snow.deep_snow}
                </p>
                <p style={{ fontSize: 10 }}>
                  {handleDate(item.latest_update_snow)}
                </p>
              </div>
              <div className="item5">
                <p>
                  {item.latest_update_snow && item.latest_update_snow.density}
                </p>
                <p style={{ fontSize: 10 }}>
                  {handleDate(item.latest_update_snow)}
                </p>
              </div>
              <div className="item6">
                <p>
                  {item.latest_update_snow
                    ? item.latest_update_snow.attitude_water_snow
                    : ""}
                </p>
                <p style={{ fontSize: 10 }}>
                  {handleDate(item.latest_update_snow)}
                </p>
              </div>
              <div className="item7">
                <p>{item.latest_update_evp && item.latest_update_evp.value}</p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_evp &&
                    item.latest_update_evp.value &&
                    handleDate(item.latest_update_evp)}
                </p>
              </div>
            </div>
            <div className="buttonBox">
              <Link
                className="link"
                to={{
                  pathname: "Chart/WeatherStation",
                  state: { name: item.name, id: item.id },
                }}
              >
                <div className="buttonFullData">اطلاعات کامل</div>
              </Link>
            </div>
          </div>
          <div className="line">
            <div></div>
          </div>
        </div>
      ))}
      {!data.length && !isLoading && (
        <div className="noItemContainer">
          <p>هیچ موردی یافت نشد</p>
        </div>
      )}
    </SpinnerHandler>
  );
};

export default WeatherStation;
